import { Injectable } from '@angular/core';
import {
  CallQueueLoginInput,
  GetUserCallQueueLoginsGQL,
  UpdateCallQueueLoginGQL,
} from '../../generated/eveportal-api/graphql';
import { debounceTime, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CallQueueService {
  constructor(
    private getCallQueueLoginsGQL: GetUserCallQueueLoginsGQL,
    private updateCallQueueLoginGQL: UpdateCallQueueLoginGQL
  ) {}

  // 🔍 Fetch all queues the user is associated with
  getUserCallQueueLogins(): Observable<CallQueueLogin[]> {
    return this.getCallQueueLoginsGQL
      .fetch(undefined, { fetchPolicy: 'network-only' })
      .pipe(
        debounceTime(300), // Add debounce to avoid rapid re-fetching
        map((result) => {
          console.log('Data fetched for dialog:', result);
          const callQueueLogin = result.data.myCallQueueLogins?.nodes || [];
          console.log('Fetched call queue logins:', callQueueLogin);
          return callQueueLogin;
        })
      );
  }

  updateCallQueueLogin(input: CallQueueLoginInput) {
    return this.updateCallQueueLoginGQL.mutate({
      logins: input, // ✅ pass as object directly
    });
  }
}

export interface CallQueueLogin {
  callQueueId: number;
  name: string;
  isLoggedIn: boolean;
}
